import React, { createContext, useState, SetStateAction, Dispatch, useEffect } from 'react';
import { CartItem } from '../interfaces/cartInterfaces';

type CartType = {
  cart: CartItem[];
  //   cartCount: number;
  setCart: Dispatch<SetStateAction<CartItem[]>>;
  clearCart: () => void;
  addToCart: (newItem: CartItem) => void;
  removeFromCart: (i: number) => void;
  decrementCartItem: (itemToDecrement: CartItem) => void;
};

export const CartContext = createContext<CartType>({} as CartType);

export const CartProvider = ({ children }: { children: React.ReactNode }) => {
  const [cart, setCart] = useState<CartItem[]>([]);

  const clearCart = () => setCart([]);

  const addToCart = (newItem: CartItem) => {
    if (cart.length === 0) {
      newItem.quantity = 1;
      setCart([newItem]);
    }

    const idArray = cart.map((item) => item.id);
    // console.log(idArray);

    if (!idArray.includes(newItem.id)) {
      newItem.quantity = 1;
      setCart([...cart, newItem]);
    } else {
      const index = idArray.indexOf(newItem.id);
      cart[index].quantity++;
      setCart([...cart]);
    }
  };

  const decrementCartItem = (itemToDecrement: CartItem) => {
    const copyOfCart = [...cart];

    const indexOfItemToDecrement = copyOfCart.findIndex(
      (element) => element.id === itemToDecrement.id
    );

    copyOfCart[indexOfItemToDecrement].quantity--;

    if (copyOfCart[indexOfItemToDecrement].quantity === 0) {
      const filteredArray = copyOfCart.filter((element) => element.id !== itemToDecrement.id);
      setCart(filteredArray);
    } else {
      setCart(copyOfCart);
    }
  };

  const removeFromCart = (i: number) => {
    cart.splice(i, 1);
    cart.length > 0 ? setCart([...cart]) : setCart([]);
  };

  const cartCount = () => {
    const count = cart.reduce((acc, curr) => {
      return acc + curr.quantity;
    }, 0);
    return count;
  };

  // FIX THIS FOR PERSISTENCE ON REFRESH!!!!!!!!!!!!!!!!!!!!!!!!!
  //   useEffect(() => {
  //     const isCartActive = JSON.parse(localStorage.getItem('cart'));
  //     isCartActive.cart?.length > 0 && setCart(isCartActive.cart);
  //   }, []);
  // FIX THIS FOR PERSISTENCE ON REFRESH!!!!!!!!!!!!!!!!!!!!!!!

  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify({ cart: [...cart] }));
  }, [cart]);

  return (
    <CartContext.Provider
      value={{
        cart,
        setCart,
        clearCart,
        addToCart,
        removeFromCart,
        // cartCount,
        decrementCartItem,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
